import Vue from 'vue'
import router from './router'
import store from './store'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import notification from 'ant-design-vue/es/notification'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import { generateIndexRouter } from "@/utils/util"
NProgress.configure({ showSpinner: false }) // NProgress Configuration
import SSO from "../src/cas/sso";

const whiteList = ['/user/login', '/user/register', '/user/register-result','/user/alteration','/mlogin','/gisPaperless/TechnologyFileBrowse',"/gisPaperless/WccOrderInsert","/gisPaperless/OrderOperationRecordList",'/ThailandErpReport'] // no redirect whitelist
router.beforeEach((to, from, next) => {
  NProgress.start() // start progress bar
  if (Vue.ls.get(ACCESS_TOKEN)) {
    /* has token */
    if (to.path === '/user/login') {
      next({ path: '/dashboard/workplace' })
      NProgress.done()
    }else if (to.path === '/mlogin') {
        next()
        NProgress.done()
    } else {
      if (store.getters.permissionList.length === 0) {
        store.dispatch('GetPermissionList').then(res => {
              const menuData = res.result.menu;
              console.log(res.message)
              if (menuData === null || menuData === "" || menuData === undefined) {
                return;
              }
              let constRoutes = [];
              constRoutes = generateIndexRouter(menuData);
              // 添加主界面路由
              store.dispatch('UpdateAppRouter',  { constRoutes }).then(() => {
                // 根据roles权限生成可访问的路由表
                // 动态添加可访问路由表
                router.addRoutes(store.getters.addRouters)
                const redirect = decodeURIComponent(from.query.redirect || to.path)
                if (to.path === redirect) {
                  // hack方法 确保addRoutes已完成 ,set the replace: true so the navigation will not leave a history record
                  next({ ...to, replace: true })
                } else {
                  // 跳转到目的路由
                  next({ path: redirect })
                }
              })
            })
          .catch(() => {
           /* notification.error({
              message: '系统提示',
              description: '请求用户信息失败，请重试！'
            })*/
            store.dispatch('Logout').then(() => {
              next({ path: '/user/login', query: { redirect: to.fullPath } })
            })
          })
      } else {
        next()
      }
    }
  } else {
      console.log(whiteList.indexOf(to.path))
      console.log(whiteList)
      console.log(to)
    if (whiteList.indexOf(to.path) !== -1) {
      // 在免登录白名单，直接进入
      next()
    } else {
      // alert('不是白名单也没有token的')
      let st = getUrlParam("ticket");
        console.log(' -- tstt1111 -- ',st)
        // alert(st)
      setTimeout(() => {
        if(st){
          // Vue.ls.set(JPGL_ticket, st, 7 * 24 * 60 * 60 * 1000)
          SSO.init(next)
          next()
        }else{
          next({ path: '/user/login', query: { redirect: to.fullPath } })
          NProgress.done() // if current page is login will not trigger afterEach hook, so manually handle it
        }
      }, 800);
       
    }
  }
})
function callback(){
  console.log(' -- mixin 2222 -- ')
  next()
}
function getUrlParam(paraName) {
  var url = document.location.toString();
  console.log('url',url)
  var arrObj = url.split("?");

  if (arrObj.length > 1) {
    var arrPara = arrObj[1].split("&");
    var arr;

    for (var i = 0; i < arrPara.length; i++) {
      arr = arrPara[i].split("=");

      if (arr != null && arr[0] == paraName) {
        console.log('arr[1]',arr[1])
        return arr[1];
      }
    }
    return "";
  }
  else {
    return "";
  }
}

router.afterEach(() => {
  NProgress.done() // finish progress bar
})
